/* eslint-disable indent */
export const VIEW_MONTH = 'month';
export const VIEW_WEEK = 'week';
export const VIEW_DAY = 'day';

export const VIEW_OPTIONS = [
  { label: 'Month', value: VIEW_MONTH },
  { label: 'Week', value: VIEW_WEEK },
  { label: 'Day', value: VIEW_DAY },
];

export const transformViewNameToViewValue = (
  viewName,
  dayViewIsTimeline = true,
) => {
  let calViewResult;

  switch (viewName) {
    case VIEW_MONTH:
    default:
      calViewResult = {
        calendar: {
          labels: true,
          outerDays: false,
        },
      };
      break;

    case VIEW_WEEK:
      calViewResult = {
        schedule: { type: 'week' },
      };
      break;

    case VIEW_DAY:
      if (dayViewIsTimeline) {
        calViewResult = {
          timeline: {
            resolutionHorizontal: 'hour',
            type: 'day',
            eventHeight: 'variable',
            columnWidth: 'medium',
          },
        };
      } else {
        calViewResult = {
          schedule: {
            type: 'day',
            showAllDay: false,
          },
        };
      }
      break;
  }

  return calViewResult;
};
